var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductSetting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 80,
    viewBox: "0 0 80 80",
    width: 80,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4013_54160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.223 17.012a2.992 2.992 0 00-.225-4.237 2.992 2.992 0 00-4.237.225l-6.875 7.637-2.763-2.762a3.025 3.025 0 00-4.25 0 2.988 2.988 0 000 4.237l5 5c.588.588 1.375.9 2.2.875a2.998 2.998 0 002.15-.987l9-10v.012zm0 20a2.992 2.992 0 00-.225-4.237 2.992 2.992 0 00-4.237.225l-6.875 7.637-2.763-2.762a2.988 2.988 0 00-4.237 0c-1.163 1.175-1.175 3.075 0 4.237l5 5c.587.588 1.375.9 2.2.875a2.998 2.998 0 002.15-.987l9-10-.013.012z",
    fill: "#0084FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.243 64.243a6 6 0 11-8.485-8.485 6 6 0 018.485 8.485z",
    fill: "#CBE6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 60c0 2.212 1.788 4 4 4h36c2.213 0 4-1.788 4-4 0-2.212-1.787-4-4-4H32c-2.212 0-4 1.788-4 4zm8-20c0 2.212 1.788 4 4 4h28c2.213 0 4-1.788 4-4 0-2.212-1.787-4-4-4H40c-2.212 0-4 1.788-4 4zm4-16h28c2.213 0 4-1.788 4-4 0-2.212-1.787-4-4-4H40c-2.212 0-4 1.788-4 4 0 2.212 1.788 4 4 4z",
    fill: "#0084FF",
    opacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4013_54160"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H64V64H0z",
    fill: "#fff",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductSetting);
export default __webpack_public_path__ + "static/media/product-setting.5bd57e567eac20aa32198b729369b2ba.svg";
export { ForwardRef as ReactComponent };